export default __webpack_public_path__ + "static/media/4.Air-hose-Pipe.b066e171.PNG";